import React, { useState } from 'react'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'
import { Subtitle } from './styled'
import {
  StyledRadio,
  RadioWrapper,
  PromptOTPWrapper,
} from './LoginScreen/elements'

const SelectOtpMethod = ({ otpMethods, maskedUserDetails, send }) => {
  const [selectedMethod, setOtpMethod] = useState(null)

  return (
    <PromptOTPWrapper>
      <Subtitle>
        To authenticate your membership, you will be receiving a One-Time
        password (OTP). Please select which method you would prefer to receive
        the OTP.
      </Subtitle>
      {otpMethods.map(
        maskedOtpValues =>
          maskedUserDetails[maskedOtpValues.key] && (
            <RadioWrapper key={maskedOtpValues.key}>
              <StyledRadio
                data-testid={maskedOtpValues.key}
                onChange={() => setOtpMethod(maskedOtpValues)}
                checked={selectedMethod?.key === maskedOtpValues.key}
                name={maskedOtpValues.key}
                value={maskedOtpValues.key}
              />
              <label
                data-testid={`${maskedOtpValues.key}-label`}
                onClick={() => setOtpMethod(maskedOtpValues)}
              >
                {maskedOtpValues.label} (
                <span>{maskedUserDetails[maskedOtpValues.key]}</span>)
              </label>
            </RadioWrapper>
          )
      )}
      <ButtonContained
        data-testid="select-otp-button"
        disabled={!selectedMethod}
        fullWidth
        onClick={() => send({ type: 'REQUEST_OTP', selectedMethod })}
      >
        Send OTP
      </ButtonContained>
    </PromptOTPWrapper>
  )
}

export default SelectOtpMethod
